import {takeLatest, takeLeading} from "redux-saga/effects";

import * as UserActions from "@atg-global-shared/user/userActionTypes";
import {TeamActions} from "@atg-tillsammans/team-data-access/redux/team";

import * as AppActions from "./appConstants";
import {GET_MEMBER_CUSTOMIZATION_REQUEST} from "./memberCustomizationConstants";
import * as CustomizationSagas from "./memberCustomizationSagas";

import type {SagaIterator} from "redux-saga";
import {TeamMemberActions} from "@atg-tillsammans/team-member-data-access";

export function* memberCustomizationSaga(): SagaIterator {
    yield takeLatest(
        GET_MEMBER_CUSTOMIZATION_REQUEST,
        CustomizationSagas.fetchMemberCustomization,
    );
    yield takeLeading(
        [
            UserActions.LOGIN_FINISHED,
            UserActions.RECEIVE_USER,
            AppActions.USER_ENTERED_TILLSAMMANS,
        ],
        CustomizationSagas.initMemberCustomization,
    );
    yield takeLeading(
        [UserActions.LOGOUT_INITIATED, AppActions.APP_CONTEXT_LEAVE],
        CustomizationSagas.cleanupMemberCustomization,
    );
    yield takeLatest(
        TeamMemberActions.setMemberTeams.type,
        CustomizationSagas.updateStartPageFlags,
    );
}
